import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class CNameConfiguration extends Model {
  id: number;
  domain: string;
  subdomain: string;
  valid: boolean;
  dns: Dns;
}
export class CNameConfigurations extends Paginated {
  data: Array<CNameConfiguration>;
}

export class Dns extends Model {
  mailCname: DnsTypeDetail;
  mailServer: DnsTypeDetail;
  spf: DnsTypeDetail;
  dkim1: DnsTypeDetail;
  dkim2: DnsTypeDetail;
}

export class DnsTypeDetail extends Model {
  host: string;
  type: string;
  data: string;
  valid: boolean;
}

export class AddDomainRequest extends Model {
  domain: string;
  subdomain?: string;
}

export enum EmailDnsValidLabel {
  VERIFY_LABEL = 'emaildns_valid',
  PENDING_LABEL = 'emaildns_verifying'
}

export enum EmailDnsStatusHTMLTagSpan {
  VERIFY = '<span class="badge badge-verified">',
  PENDING = '<span class="badge badge-archived">'
}
